module.exports = __webpack_public_path__ + "static/media/016.1f483a6b.jpg";